var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sys-select-base',{attrs:{"model":_vm.selected,"items":_vm.items,"label":_vm.label,"error":_vm.error,"errors":_vm.errors,"showAdd":_vm.showAdd,"clearable":_vm.clearable,"disabled":_vm.disabled,"dense":_vm.dense,"multiple":_vm.multiple,"itemText":_vm.itemText},on:{"update:model":function($event){_vm.selected=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }